module.exports = __webpack_public_path__ + "static/projekt_indywidualny_e05-fa00fc9a362f1040111fdad9dc76f263.jpg";